import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getCmsConfig, saveCmsConfig } from "./callbacks";

export const useGetCmsConfig = <T>(page: string) => {
  return useQuery({
    queryKey: [`/cms/${page}/details`],
    queryFn: async () => {
      const res = await getCmsConfig<T>(page);
      return res.data;
    },
  });
};

export const useSaveCmsConfig = <T>({
  page,
  onSuccess,
  onError,
}: {
  page: string;
  onSuccess?: () => void;
  onError?: (err: any) => void;
}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<T>) => saveCmsConfig<T>(page, data),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [`/cms/${page}/details`] });
      onSuccess?.();
    },
    onError: (err: any) => {
      onError?.(err);
    },
  });
};
